import { EventTargets } from 'core-lib/constants/events';
import { EventAttributes, EventName } from 'core-lib/types/Events';
import { trackEventFunction } from 'core-lib/utils/eventTracking';
import { isServer } from 'core-lib/utils/utils';

const TYPED_ATTR_KEYS = new Set([
  'category',
  'pageName',
  'tabName',
  'popupName',
  'sectionName',
  'scrollDirection',
  'cardName',
  'bannerName',
  'ctaName',
  'promoCode',
  'position',
  'optionSelected',
  'vehicleId',
]);

const getFormattedKeys = (attributes: EventAttributes) => {
  return {
    category: attributes.category,
    page_name: attributes.pageName,
    tab_name: attributes.tabName,
    popup_name: attributes.popupName,
    section_name: attributes.sectionName,
    scroll_direction: attributes.scrollDirection,
    card_name: attributes.cardName,
    banner_name: attributes.bannerName,
    cta_name: attributes.ctaName,
    promo_code: attributes.promoCode,
    position: attributes?.position,
    option_selected: attributes?.optionSelected,
    vehicle_id: attributes?.vehicleId,
  };
};

const getPassthroughKeys = (attributes: Record<string, any>) => {
  const passthrough: Record<string, any> = {};
  Object.keys(attributes || {}).forEach(key => {
    if (!TYPED_ATTR_KEYS.has(key)) {
      passthrough[key] = attributes[key];
    }
  });
  return passthrough;
};

// @WARNING: DON'T PASS attributes type to any, it'll defeat the purpose
export const trackEvent: (
  name: EventName,
  attributes: EventAttributes,
  eventTarget?: EventTargets[],
) => void = (name, attributes, eventTarget) => {
  if (!isServer() && !!attributes) {
    trackEventFunction(
      name,
      {
        ...getFormattedKeys(attributes),
        ...getPassthroughKeys(attributes as Record<string, any>),
      },
      eventTarget,
    );
  }
};

export default trackEvent;
